module.exports = __webpack_public_path__ + "img/四川天府新区麓湖幼儿园.1ced1cd9.jpg";